module.exports = __webpack_public_path__ + "img/CompletedGreenE.f7cf3fcf.png";